import CriarLancamentoForm from './CriarLancamentoForm';
import GerarLancamentoForm from './GerarLancamentoForm';

export default { CriarLancamentoForm, GerarLancamentoForm };
